import * as React from 'react';
import { PageSection } from '../../../atoms/layout/PageSection';
import { LocationSelector } from '../../../molecules/forms/LocationSelector';
import { LoaderRow } from '../../../atoms/layout/LoaderRow';
import { EventListPane } from '../EventListPane';
import { GlobalStatesV3 } from '../../../../../commonv3/states/GlobalStatesV3';
import { V3Routes } from '../../../../routes';
import { observer } from 'mobx-react';
import './eventSection.module.scss';
import { Link } from 'react-router-dom';

export const EventSection = observer(({ currentUser, eventList, locations }) => {
    const { selectedLocationSelectors, setSelectedLocationSelectors, eventArchives, events, hasArchives } = eventList;
    return (
        <PageSection title="EVENT" subTitle="イベント" background="white" id={'event-list-section'}>
            <div styleName="header">
                <div styleName="header-box">
                    <div styleName="header-box-inner">
                        <div styleName="header-text">表示する拠点</div>
                        <LocationSelector
                            locations={locations.getOrElse([])}
                            homeLocationId={currentUser.homeLocation.locationId}
                            showOnline={true}
                            showOnlineFirst={true}
                            isHomeLocationSet={currentUser.homeLocation.isHomeLocationSet}
                            locationSelectors={selectedLocationSelectors}
                            onChange={setSelectedLocationSelectors}
                        />
                    </div>
                </div>
                {hasArchives && (
                    <div styleName="header-link-wrapper">
                        <Link styleName="link" to={V3Routes.eventArchives()}>
                            過去のイベント動画はこちら
                        </Link>
                    </div>
                )}
            </div>

            {events.loading && <LoaderRow />}
            <EventListPane
                events={eventList.filteredSessions}
                onItemClick={(ev) => GlobalStatesV3.routing.push(V3Routes.event(ev.id))}
            />
            {eventArchives.loading && <LoaderRow />}
        </PageSection>
    );
});
